import { useContext } from "react";
import { Link } from "react-router-dom";
import { Button } from "@blueprintjs/core";
import { faCabinetFiling } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { WorkbenchContext } from "@pages/editor/providers";

import { RuleSharePreview } from "./RuleSharePreview";
import { CleanDialog, DialogBody, VisibilityWarning } from "./RuleShareUtils";

/**
 * Share dialog for existing public rules (registry rules)
 */
export const RegistryRuleShareDialog = () => {
  const { workbench } = useContext(WorkbenchContext);
  return (
    <CleanDialog
      isOpen={true}
      onClose={workbench.ui.closeRuleShareDialog}
      title="Share public rule"
    >
      <DialogBody>
        <RuleSharePreview
          input={"https://semgrep.dev/r/" + workbench.address!.fullName}
        />
        <VisibilityWarning>Visible in registry.</VisibilityWarning>

        <div
          style={{
            marginTop: "32px",
          }}
        >
          <Link
            to={"/r/" + workbench.address!.fullName}
            style={{
              textDecoration: "none",
            }}
          >
            <Button>
              <FontAwesomeIcon
                icon={faCabinetFiling}
                style={{ marginRight: "8px" }}
              />
              See in registry
            </Button>
          </Link>
        </div>
      </DialogBody>
    </CleanDialog>
  );
};
